import { render, staticRenderFns } from "./EmotionWheelPublicDisplayItem.vue?vue&type=template&id=260e1656"
import script from "./EmotionWheelPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./EmotionWheelPublicDisplayItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260e1656')) {
      api.createRecord('260e1656', component.options)
    } else {
      api.reload('260e1656', component.options)
    }
    module.hot.accept("./EmotionWheelPublicDisplayItem.vue?vue&type=template&id=260e1656", function () {
      api.rerender('260e1656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/EmotionWheelPublicDisplayItem.vue"
export default component.exports